import { IconButton } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { CopyToClipboard } from 'src/components/CopyToClipboard';
import { CopyIcon } from 'src/components/icons';
import { BlackHeadings } from 'src/theme/colors';

interface StyleProps {
  spacing: string;
}

interface CopyTextProps {
  value: string;
  iconPosition?: 'start' | 'end';
  spacing?: string;
}

const useStyles = makeStyles<StyleProps>()((_theme, { spacing }) => ({
  root: {
    display: 'flex',
    justifyContent: spacing,
  },
  copyIcon: {
    fontSize: 12,
    color: BlackHeadings,
    '& path': {
      strokeWidth: 1.75,
    },
  },
}));

/**
 * Render prop component that allows for copying value
 * and child component will be rendered adjust to copy icon
 *
 * @deprecated Use `CopyText` from `src/components/CopyText` instead.
 */
export const CopyText: React.FC<CopyTextProps> = ({
  value,
  iconPosition = 'start',
  spacing = 'flex-start',
  children,
}) => {
  const { classes } = useStyles({ spacing });

  const handleCopyClicked = (
    ev: React.MouseEvent<HTMLButtonElement>,
    copyFunction: (content: any) => void,
  ) => {
    ev.stopPropagation();
    copyFunction(value);
  };
  const wrappedChildren = (
    <div className="overflow-auto whitespace-nowrap">{children}</div>
  );
  return (
    <div className={classes.root}>
      {iconPosition === 'end' && wrappedChildren}
      <CopyToClipboard>
        {({ copy }) => (
          <IconButton
            onClick={(ev) => handleCopyClicked(ev, copy)}
            size="small"
          >
            <CopyIcon className={classes.copyIcon} />
          </IconButton>
        )}
      </CopyToClipboard>
      {iconPosition === 'start' && wrappedChildren}
    </div>
  );
};
